export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 50,
    slots: {
      default: 'opt'
    },
    showHeaderOverflow: 'title'
  },
  {
    field: 'functionName',
    minWidth: 120,
    title: that.$l('form_label_functionName') || '接口名称',
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'recordNo',
    title: that.$l('form_label_recordNo') || '记录编号',
    minWidth: 120,
    align:'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string'
  },
  {
    field: 'recordJson',
    title: that.$l('form_label_recordJson') || '返回记录',
    minWidth: 250,
    align:'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    title: that.$l('form_label_recordStatus') || '记录状态',
    width: 100,
    align: 'center',
    slots: { default: 'status' },
    showHeaderOverflow: 'title'
  },
  {
    field: 'creationTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.create_date') || '创建时间',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string'
  },
  {
    field: 'updatedTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string'
  }
]
